import { isNonNullableObject } from "@knyt/artisan";
/**
 * Checks if a value is serializable to CSS.
 */
export function isCSSSerializable(value) {
    return (isNonNullableObject(value) &&
        "toCSSString" in value &&
        typeof value.toCSSString === "function");
}
